import { connect } from 'react-redux';
import { BillingInformationModal } from './component';
import {
  fetchPaymentForCurrentSubscription,
  updateBillingDetailsForCurrentSubscription,
} from '../../../../ReduxStorage/UserSubscriptionPlans/dispatchers';

export const ConnectedBillingInformationModal = connect(null, {
  fetchPaymentForCurrentSubscription,
  updateBillingDetailsForCurrentSubscription,
})(BillingInformationModal);
